import React, { useState } from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import ErrorIcon from '../Assets/SVG/errorIcon';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';
import { isMobile } from 'react-device-detect';
import ArrowSignErrorIcon from '../Assets/SVG/arrowSignErrorIcon';

const TalkmanScreen = (props) => {

    const mobileCall = (
        <BtnSubmit
            className='btn-submit-white TipCallBtn mb-20'
            isDisplayWhatsAppIcon={false}
            onclick={() => {
                window.location.href = 'tel:*778';
            }}
            text='לשירות לקוחות חייגו 778*'
        />
    );
    const desktopCall = <div className='TipCall mb-20'>לשירות לקוחות חייגו 778*</div>;
    return (
        <div className='screenContainer'>
            <ArrowSignErrorIcon />
            <h3 className='heading withSecondary'>רק רגע</h3>
            <h4 className='secondaryHeading errorSecondary'>שמנו לב שמדובר בלקוח טוקמן,<br />לקבלת שירות אנא פנו לשירות הלקוחות<br />בשעות הפעילות</h4>

            {isMobile ? mobileCall : desktopCall}
            <BtnSubmit onclick={() => { window.location.href = Config.staticWebSiteUrl }} text="לעמוד הבית " />
        </div>
    );
};

export default TalkmanScreen;
